// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"729":"ed23f7c9","787":"ae0cf68a"}[chunkId] + ".chunk.js";
};